// This env list is using '.tamara.co'
import locator from '@/service-locator'
import { isLocalhost } from '@/utils/enviroment'

const ENV_LIST = ['production', 'staging', 'sandbox']

const getDomainFromEnv = (env) => {
  return ENV_LIST.includes(env) ? 'tamara.co' : 'tamaratech.co'
}

const getTamaraDomainCookieAttributes = (global, optionAttrs = {}) => {
  const domain = getDomainFromEnv(locator.config.env)
  const cookieAttributes = isLocalhost(global) ? {} : { domain, secure: true }

  return { ...cookieAttributes, ...optionAttrs }
}

export { getTamaraDomainCookieAttributes }
